export default ({
  namespaced: true,
  state: {
    view: 'dialogPlan',
    values: {title: '', text: '', showDialog: false}
  },
  getters: {
    values: state => {
      return state.values
    }
  },
  mutations: {
    change_values (state, payload) {
      Object.assign(state.values, payload)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/dialogPlan.js